/**
 * 大屏配置
 */
const themeColor = {
    //【主色调】--------
    main_light: '#50f0fe',//一些文字配色
    main_mid: '#15466a',
    main_dark: '#0d2a42',//大屏主体背景

    //【放学配色】------
    over_before: '#ffffff',//未放学
    over_ing: '#ff0000',//放学中
    over_after: '#00ff00',//已放学

    //【大屏中央边框配色】-----
    border_line:'#15466a',//边框线
    border_radius:'#50f0fe',//边框拐角
    border_content: '#05355e',//大屏边框内部背景

    //【顶部加载动画条颜色】
    loading_color_ok:'#50f0fe',
    loading_color_err:'#fea935',

    header_title_normal_color:'#ffffff',//标题色
    header_title_heart_check_color:'#50f0fe',//检测心跳色
    header_title_heart_pushed_color:'#00ff00',//推数据色

    //【通知栏】文字颜色-----
    notice_bar_text_color:'#ffff00',
    //背景色：#0d2a42
    notice_bar_bg_color:'rgba(0,0,0,.5)',

    //【指示牌】文字颜色-----
    signage_text_color:'#ffff00',
}
//测试用设备id
const deviceId = '264bf666a3431220';

//【通知】-----------
//通知轮播次数，过后是时间间隔。
const noticeScrollCount = 2;
//通知轮播后的间隔，单位秒
const noticeScrollPeriod = 20;

//【命令】
const commander = {
    rebootApp:1,//重启app
    refresh:2,//刷新页面
}
export {
    themeColor,
    deviceId,
    noticeScrollCount,
    noticeScrollPeriod,
    commander
}
